import { render, staticRenderFns } from "./ImsakiyeCard.vue?vue&type=template&id=2e1abfb4&scoped=true&"
import script from "./ImsakiyeCard.vue?vue&type=script&lang=js&"
export * from "./ImsakiyeCard.vue?vue&type=script&lang=js&"
import style0 from "./ImsakiyeCard.vue?vue&type=style&index=0&id=2e1abfb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1abfb4",
  null
  
)

export default component.exports